import { Stack, Typography, Box } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { background, black, divider, text } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";
import { TMockExamAttempt } from "@/infrastructure/adapters/mock-exam/mock-exam.types";
import { HistoryItem } from "@/features/mock-exam/components/mock-exam/HistoryItem";

/**
 * Mock Exam history section showing past mockExam attempts.
 */
export const HistorySection: FC<{ attempts: TMockExamAttempt[] }> = ({ attempts }) => {
  const { t } = useTranslation();
  const hasAttempts = attempts.length > 0;

  return (
    <Box px={spacing.sm}>
      <Stack p={spacing.sm} gap={spacing.smd} borderRadius={rounded.xs} border={`1px solid ${divider.high}`} bgcolor={background.white}>
        {hasAttempts ? (
          <>
            <Typography variant="body14Bold" color={text.primary}>
              {t("mockExam.history.title")}
            </Typography>
            <Stack gap={spacing.smd}>
              {attempts.map((item) => (
                <HistoryItem key={item.attemptId} item={item} />
              ))}
            </Stack>
          </>
        ) : (
          <>
            <Typography variant="sub16Semi" color={text.primary}>
              {t("mockExam.history.title_empty")}
            </Typography>
            <Typography variant="sub16Semi" color={black[70]}>
              {t("mockExam.history.empty")}
            </Typography>
          </>
        )}
      </Stack>
    </Box>
  );
};
